import React from 'react';
import PropTypes from 'prop-types';
import styles from './TicketMetricsCard.module.css';

export const TicketMetricsCard = ({ 
  label, 
  value, 
  isSelected, 
  onClick,
  variant = 'default'
}) => {
  return (
    <div 
      className={`${styles.card} ${isSelected ? styles.selected : ''} ${styles[variant]}`}
      onClick={onClick}
    >
      <div className={styles.content}>
        <h3 className={styles.label}>{label}</h3>
        <div className={styles.value}>{value}</div>
      </div>
    </div>
  );
};

TicketMetricsCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'primary'])
};